module.exports = __webpack_public_path__ + "images/emoji/cd.f0c0ec0661fe736a6ef8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/cd.png
// module id = kFSk
// module chunks = 2